module.exports = __webpack_public_path__ + "img/tip.00fe1c5.png";